module.exports = ( $scope, $uibModalInstance, request ) ->

  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  $scope.ok = ->
    content = $scope.extra
    if $scope.content
      content += '. Search Result: ' + $scope.content
    $uibModalInstance.close content

  $scope.init = () ->
    if typeof request?.content?.extra is 'object'
      $scope.content = [" #{k}: #{v}" for k, v of request.content.extra].join(",")
    else if request?.content?.snippet
      $scope.content = request?.content?.snippet
    else
      $scope.content = ""

    $scope.extra = ""
    $scope.request = request

  $scope.init()
